import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 40E06CC0-82EE-4EE0-976B-C6388BBFDD9D
 * name turnstile
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/turnstile.svg
 * tags
 */
export const TurnstileIcon = createSvgIcon(<><path d="M22,22H16V11L10,5V2H22V22M9.17,6.17C8.42,6.92 8,7.94 8,9H2V11H8.55C8.9,11.6 9.4,12.1 10,12.45V19H12V13C13.06,13 14.08,12.58 14.83,11.83L9.17,6.17Z" /></>, 'TurnstileIcon');
export default TurnstileIcon